import React, {useState, useEffect, useLayoutEffect} from 'react'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { useNavigate, useLocation } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import AnnouncementData from '../../JSON/announcements.json'
import { jwtDecode } from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import '../Styles/AdminAnnouncementDetail.css'
import { deleteAnnouncement, editAnnouncement, fetchAnnouncementDetail } from '../Controller/AnnouncementController';

const AdminAnnouncementDetail = () => {

    const customTheme = (theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#4caf50", // Adjust the primary color as needed
          primary75: "#1a4b11", // Adjust the primary light color as needed
        },
      });

    const navigate = useNavigate();

    const urlLocation = useLocation();
    const queryParamsAnnouncement = new URLSearchParams(urlLocation.search);
    const announcementId = queryParamsAnnouncement.get('id');

    const [announcement, setAnnouncement] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [endDate, setEndDate] = useState(null);

    const [loading, setLoading] = useState(false);
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [failure, setFailure] = useState(false);
    const [emptyTokenFlag, setEmptyTokenFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);

    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        const handleFetchAnnouncementDetail = async () => {
            try{
                setLoading(true);
                const response = await fetchAnnouncementDetail(announcementId);
                const status = response.status;

                if(status === 200){
                    const announcementFound = response.data.announcement;
                    setAnnouncement(announcementFound || {});
                    if(announcementFound){
                        setTitle(announcementFound?.title);
                        setDescription(announcementFound?.description);
                        setEndDate(announcementFound?.endDate);
                    }
                } else {
                    console.log("response" + response);
                    setSeveritySnackbar("error");
                    setMessageSnackbar(response?.data?.message || "An error has occurred");
                    setSnackbarDuration(3000);
                    setOpenSnackbar(true);                  
                }
    
            }catch(error)  {
                if(error?.response?.status === 404){
                    console.log("OLA");
                    setSeveritySnackbar("error");
                    setMessageSnackbar(error?.response?.data?.message || "No Announcement found");
                    setSnackbarDuration(3000);
                    setSuccess(true);
                    setOpenSnackbar(true); 
                } else{
                    setMessageSnackbar(error?.response?.data?.message || "An error occurred")
                    setSeveritySnackbar("error");
                    setOpenSnackbar(true);
                }
            }finally{
                setLoading(false);
            }
        }

        handleFetchAnnouncementDetail();

    }, [])

    useEffect(() => {
        if(!openSnackbar && emptyTokenFlag){
            setEmptyTokenFlag(false);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return
        }
    }, [openSnackbar && emptyTokenFlag])

    useEffect(() => {
        if(!openSnackbar && success){
            setSuccess(false);
            navigate('/admin-dashboard/announcements');
        }

        if(!openSnackbar && failure){
            setFailure(false);
        }

        if(!openSnackbar && finishFlag){
            setFinishFlag(false);
        }
    }, [success && openSnackbar, failure && openSnackbar, finishFlag && openSnackbar]) 

    useEffect(() => {
        window.scrollTo(0,0);
    },[])


    const handleCloseOverlay = () => {
        setShowOverlay(false);
    }

    const handleOpenOverlay = () => {
        // if(!title){
        //     return;
        // }
        setShowOverlay(true);
    }


    const handleMoveBack = (e) => {
        e.preventDefault();
        navigate('/admin-dashboard/announcements')
    }

    // const tokenChecker = () => {
    //     let token = localStorage.getItem('authToken');
    //     if (!token) {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token not found, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         localStorage.removeItem('authToken');
    //         navigate("/admin");
    //         return null;
    //     }

    //     let decodedToken = jwtDecode(token);

    //     if (decodedToken && decodedToken.exp * 1000 > Date.now()){
    //         return;
    //     } else {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token has expired, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         localStorage.removeItem('authToken');
    //         navigate("/admin");
    //         return null;
    //     }
    // }

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
        //   handleGenerateReport(event);
        }
      };

    const getCurrentDate = () => {
        const currentDate = new Date();
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return currentDate.toLocaleDateString('en-CA', options);
    };

    const formatDate = (dateString) => {
        if(!dateString) return getCurrentDate();
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return date.toLocaleDateString('en-CA', options);
    }

    const minDate = new Date();

    const handleDeleteAnnouncement = async(e) => {
        e.preventDefault();

        try{
            setLoadingOverlay(true);
            const response = await deleteAnnouncement(announcementId);
            const status = response.status;
            if (status === 200) {

                setSeveritySnackbar("success");
                setMessageSnackbar(response?.data?.message);
                setOpenSnackbar(true);
                setSnackbarDuration(3000);
                setSuccess(true);
                
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occured, please try again");
                setFailure(false);
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
        } catch (error) {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No product found");
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true); 
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }

        } finally{
            setLoadingOverlay(false);
        }
    }

    const handleEditProduct = async (e) => {
        e.preventDefault();

        if(!title || !description || !endDate) return;

        // tokenChecker();

        const announcement = {
            "title": title,
            "description": description,
            "endDate": endDate
        }

        try{
            setLoadingOverlay(true);

            const response = await editAnnouncement(announcementId, announcement);
         
            if(response.status === 200){
                setSeveritySnackbar('success')
                setMessageSnackbar(response?.data?.message);
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true);
            } else {
                console.log("response" + response);
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occurred");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
                
            }
            
        }   catch (error) {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No product found");
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true); 
            } else{
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setFinishFlag(true);
                setOpenSnackbar(true);
            }
        } finally{
            setLoadingOverlay(false);
        }
    }

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    return(
        <>
            <div className='admin-announcement-detail-container' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}}>
                <div className='admin-announcement-detail-header-container'>
                    <h4 className='admin-announcement-detail-header'>
                        Announcement Detail
                    </h4>
                    <div className='admin-announcement-detail-delete-btn-container'>
                        <span className='fa-solid fa-trash-can admin-announcement-detail-delete-btn' onClick={handleOpenOverlay}></span> 
                    </div>
                </div>
                {(!loading && announcement) &&
                    <>
                        <form className='admin-announcement-detail-contents' onSubmit={handleEditProduct}>
                            <div className='admin-announcement-detail-label-input-container'>
                                <label htmlFor='title' className='admin-announcement-detail-label'>
                                    Title
                                </label>
                                <input 
                                    type='text'
                                    id='title'
                                    className='admin-announcement-detail-input'
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    required
                                /> 
                            </div>
                            <div className='admin-announcement-detail-label-input-container'>
                                <label htmlFor='description' className='admin-announcement-detail-label'>
                                    Description
                                </label>
                                <textarea
                                    id='description'
                                    className='admin-announcement-detail-input'
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    rows={7}
                                    required
                                /> 
                            </div>
                            <div className='admin-announcement-detail-label-input-container'>
                                <label htmlFor='end-date' className='admin-announcement-detail-label'>
                                    End Date
                                </label>
                                <DatePicker
                                    selected={endDate}
                                    value={formatDate(endDate)}
                                    onChange={(date) => setEndDate(date)}
                                    selectsStart
                                    minDate={minDate}
                                    dateFormat="dd/MM/yyyy"
                                    showTimeSelect={false}
                                    className={`custom-datepicker admin-announcement-detail-input`}
                                    calendarClassName="custom-calendar"
                                    theme={customTheme}
                                    onKeyPress={handleKeyPress}
                                    id="end-date"
                                />
                            </div>

                            <div className='admin-announcement-detail-btn-container'>
                                <button className='admin-announcement-detail-cancel-btn' onClick={handleMoveBack}>
                                    Cancel
                                </button>
                                <button className='admin-announcement-detail-save-btn' type='submit'>
                                    Save
                                </button>
                            </div>
                        </form>       
                    </>
                }

                <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='black' />
                </div>

                <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                    <ClipLoader color='white' size={100} />
                </div>
                
            </div>

            {showOverlay && (
            <div className="overlay-container" style={{color: 'black'}} onClick={() => setShowOverlay(false)}>
                <div className={`overlay-content`} onClick={handleStopPropagation}>
                    <h4 className={`delete-overlay-header`}>Announcement</h4>
                    <h6 className={`delete-overlay-text`}>Are you sure to delete the announcement?</h6>
                    <div className="delete-overlay-btn-container">
                        <button className={`delete-overlay-cancel-btn`} onClick={handleCloseOverlay}>
                            No
                        </button>
                        <button className="delete-overlay-ok-btn" onClick={handleDeleteAnnouncement}>
                            Yes 
                        </button>
                    </div>
                    <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                            <ClipLoader color='white' size={100} />
                    </div>
                </div>
            </div>
        )} 

            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default AdminAnnouncementDetail;